import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const CardsTypeIcon = (props) => {
    return (_jsx("svg", Object.assign({ width: "39", height: "50", viewBox: "0 0 39 50", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsxs("g", Object.assign({ id: "Card" }, { children: [_jsx("rect", { id: "Rectangle 38", x: "0.899186", y: "3.74456", width: "32.6469", height: "44.8203", rx: "3.59669", transform: "rotate(-5 0.899186 3.74456)", fill: props.color, stroke: "white", strokeWidth: "1.66001" }), _jsx("circle", { id: "Ellipse 2", cx: "19.1139", cy: "24.6468", r: "7.74671", transform: "rotate(-5 19.1139 24.6468)", stroke: "white", strokeWidth: "1.10667" })] })) })));
};
CardsTypeIcon.defaultProps = {
    color: 'white',
};
export default CardsTypeIcon;
